import { http } from "../http"

class CashManagementFetchApi {
    static async createDrawer(createData) {
        try {
            const res = await http.post(`/safe-drawers/create`, createData)
            return res.data.result
        } catch (err) {
            console.log("error in fetching safe or drawers", err)
            throw err
        }
    }
    static async updateSafeDrawer(id, data) {
        try {
            const res = await http.patch(`/safe-drawers/${id}`, data)
            return res.data.result
        } catch (err) {
            console.log("error in cashing out", err)
            throw err
        }
    }

    static async fetchSafeOrDrawers(parentId) {
        try {
            const res = await http.get(`/safe-drawers?parent=${parentId || ""}`)
            return res.data.result
        } catch (err) {
            console.log("error in fetching safe or drawers", err)
            throw err
        }
    }

    static async fetchSafeOrDrawerDetail(id, allData = false) {
        try {
            const res = await http.get(`/safe-drawers/${id}`)
            if (allData) {
                return res.data
            }
            return {
                ...res.data.result,
                lastCashOutSnapshot: res.data.lastCashOutSnapshot,
            }
        } catch (err) {
            console.log("error in fetching safe or drawers", err)
            throw err
        }
    }

    static async fetchSafeOrDrawerActivity(id, params = {}) {
        try {
            const res = await http.get(`/safe-drawers/${id}/activity`, { params })
            return res.data
        } catch (err) {
            console.log("error in fetching safe or drawer activity", err)
            throw err
        }
    }

    static async fetchWarehouseSummary(warehouseId) {
        try {
            const res = await http.get(`/safe-drawers/warehouse-summary?warehouse_id=${warehouseId}`)
            return res.data
        } catch (err) {
            console.log("error in fetching warehouse summary", err)
            throw err
        }
    }

    static async fetchSafeOrDrawerSummary(safeDrawerId, debug = false) {
        try {
            const debugParam = debug ? '&debug=true' : '';
            const res = await http.get(`/safe-drawers/safe-summary?safe_drawer_id=${safeDrawerId}${debugParam}`)
            return res.data
        } catch (err) {
            console.log("error in fetching safe drawer summary", err)
            throw err
        }
    }

    static async fetchSafeOrDrawerTransactions(safeDrawerId) {
        try {
            const res = await http.get(`/safe-drawer-transactions/${safeDrawerId}`)
            return res.data.result
        } catch (err) {
            console.log("error in fetching safe or drawers", err)
            throw err
        }
    }

    // Fetch expected amounts (SafeDrawerAmount rows) for a given safe/drawer id
    // Used to compute "Available in Safe" for parent safes
    static async fetchExpectedAmounts(safeDrawerId) {
        try {
            const res = await http.get(`/safe-drawers/${safeDrawerId}/expected-amounts`)
            return res.data.result || []
        } catch (err) {
            console.log("error in fetching expected amounts", err)
            throw err
        }
    }

    static async fetchExpectedAmountsPayload(safeDrawerId) {
        try {
            const res = await http.get(`/safe-drawers/${safeDrawerId}/expected-amounts`)
            return res.data
        } catch (err) {
            console.log("error in fetching expected amounts payload", err)
            throw err
        }
    }

    static async fetchRetainedFloatConfig() {
        try {
            const res = await http.get(`/safe-drawers/retained-float-config`)
            return res.data.result
        } catch (err) {
            console.log("error in fetching retained float config", err)
            throw err
        }
    }

    static async updateRetainedFloatConfig(payload) {
        try {
            const res = await http.patch(`/safe-drawers/retained-float-config`, payload)
            return res.data.result
        } catch (err) {
            console.log("error in updating retained float config", err)
            throw err
        }
    }

    static async fetchCheckoutPolicyConfig() {
        try {
            const res = await http.get(`/safe-drawers/checkout-policy-config`)
            return res.data.result
        } catch (err) {
            console.log("error in fetching checkout policy config", err)
            throw err
        }
    }

    static async updateCheckoutPolicyConfig(payload) {
        try {
            const res = await http.patch(`/safe-drawers/checkout-policy-config`, payload)
            return res.data.result
        } catch (err) {
            console.log("error in updating checkout policy config", err)
            throw err
        }
    }

    static async fetchAccountAutomationSettings() {
        try {
            const res = await http.get(`/customers/account-automation-settings`)
            return res.data.result
        } catch (err) {
            console.log("error in fetching account automation settings", err)
            throw err
        }
    }

    static async updateAccountAutomationSettings(payload) {
        try {
            const res = await http.patch(`/customers/account-automation-settings`, payload)
            return res.data.result
        } catch (err) {
            console.log("error in updating account automation settings", err)
            throw err
        }
    }

    static async fetchSafeOrDrawerTransactionAmounts(safeDrawerId) {
        try {
            const res = await http.get(`/safe-drawer-transaction-amounts/${safeDrawerId}`)
            return res.data.result
        } catch (err) {
            console.log("error in fetching safe or drawers", err)
            throw err
        }
    }

    static async safeDrawerCashIn(cashInData) {
        try {
            const res = await http.post(`/safe-drawers/cash-in`, cashInData)
            return res.data.result
        } catch (err) {
            console.log("error in cashing in", err)
            throw err
        }
    }

    static async safeDrawerCashOut(cashOutData) {
        try {
            const res = await http.post(`/safe-drawers/cash-out`, cashOutData)
            return res.data.result
        } catch (err) {
            console.log("error in cashing out", err)
            throw err
        }
    }
}

export default CashManagementFetchApi
